<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="5" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -1"></div>
    <Submenu v-if="!Bignav" :Info="SubInfo" :DividNum="4" :BGImgUrl="'sbg0102.png'" :Submenu="Submenu" v-on:cellback="Navgo" style="z-index: -6"></Submenu>
    <router-view/>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Submenu from '@/components/Submenu.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      SubInfo:
        {
          title:'多癌種放射治療',
          body:""
        },
      Submenu:[
        {
          id:'01',
          text:'何謂放射線治療'
        },
        {
          id:'02',
          text:'肺癌'
        },
        {
          id:'03',
          text:'乳癌'
        },
        {
          id:'04',
          text:'頭頸癌'
        },
        {
          id:'05',
          text:'攝護腺癌'
        },
        {
          id:'06',
          text:'腦瘤'
        }
      ]

    }
  },
  components: {
    Back,Submenu,Bigmenu
  },
  methods:{
    Navgo(v){
      switch (v) {
        case 0:
          this.$router.push('/R01')
          break
        case 1:
          this.$router.push('/R03')
          break
        case 2:
          this.$router.push('/R04')
          break
        case 3:
          this.$router.push('/R05')
          break
        case 4:
          this.$router.push('/R06')
          break
        case 5:
          this.$router.push('/R07')
          break

      }

    },
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
